module.exports = __webpack_public_path__ + "media/packs/faq/images/close-226da284a0edd710b987cfa432fb3de8.svg";